import React from 'react'

function HappyHourDays() {
  return (
    <div id="hhDaysDiv">
      <h2>Happy Hour</h2>
      <div className="hhDatesTimes">
        <p>Monday - Friday:</p>
        <p>3pm - 7pm</p>
      </div>
      <div className="hhDatesTimes">
        <p>Monday - Thursday:</p>
        <p>10pm - 12am</p>
      </div>
    </div>

  )
}

export default HappyHourDays
